<template>
  <div>
    <template v-if="$vuetify.breakpoint.lgAndUp">
      <v-card-actions class="pa-1">
        <v-select v-model="selectedOrder" label="Sort By" :items="orderByItems" item-text="name" item-value="name" return-object mandatory></v-select>
        <v-spacer></v-spacer>
        <v-menu>
          <template v-slot:activator="{on}">
            <v-chip v-on="on" :color="qa_approved === true ? 'success' : qa_approved === false ? 'error' : ''" label>Qa Approved: {{qa_approved === null ? 'NF' : qa_approved}}</v-chip>
          </template>
          <v-list>
            <v-list-item v-for="(qaStatus, index) in qaApprovedSelectOptions" :key="index" @click="qa_approved = qaStatus.value">
              <v-list-item-title>{{qaStatus.text}}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-spacer></v-spacer>
        <v-menu>
          <template v-slot:activator="{on}">
            <v-chip v-on="on" :color="is_released === true ? 'success' : is_released === false ? 'error' : ''" label>Released: {{is_released === null ? 'NF' : is_released}}</v-chip>
          </template>
          <v-list>
            <v-list-item v-for="(releaseStatus, index) in releasedSelectOptions" :key="index" @click="is_released = releaseStatus.value">
              <v-list-item-title>{{releaseStatus.text}}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-spacer></v-spacer>
        <v-btn-toggle @change="" v-model="scopes" multiple>
          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-btn v-on="on" value="awaitingPrep">
                <v-chip class="error white--text" x-small></v-chip>
              </v-btn>
            </template>
            <span>Samples Awaiting Prep</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-btn v-on="on" value="testWeighed">
                <v-chip class="amber black--text" x-small></v-chip>
              </v-btn>
            </template>
            <span>Samples with tests that are weighed(prepped)</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-btn v-on="on" value="qaAbleTest">
                <v-chip class="success white--text" x-small></v-chip>
              </v-btn>
            </template>
            <span>Samples With tests waiting for QA</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-btn v-on="on" value="qaRetest">
                <v-chip class="purple white--text" x-small></v-chip>
              </v-btn>
            </template>
            <span>Samples With Retests and no analytes</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-btn v-on="on" value="testComplete">
                <v-chip class="blue white--text" x-small></v-chip>
              </v-btn>
            </template>
            <span>Samples With Completed Tests</span>
          </v-tooltip>
        </v-btn-toggle>
        <v-spacer></v-spacer>
        <v-text-field v-model="sample_note" label="Search notes" clearable></v-text-field>
        <v-spacer></v-spacer>
      </v-card-actions>
    </template>
    <template v-else>
      <v-col cols="12">
        <v-select v-model="selectedOrder" label="Sort By" :items="orderByItems" item-text="name" item-value="name" return-object mandatory></v-select>
        <v-menu>
          <template v-slot:activator="{on}">
            <v-chip v-on="on" :color="qa_approved === true ? 'success' : qa_approved === false ? 'error' : ''" label>Qa Approved: {{qa_approved === null ? 'NF' : qa_approved}}</v-chip>
          </template>
          <v-list>
            <v-list-item v-for="(qaStatus, index) in qaApprovedSelectOptions" :key="index" @click="qa_approved = qaStatus.value">
              <v-list-item-title>{{qaStatus.text}}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu>
          <template v-slot:activator="{on}">
            <v-chip v-on="on" :color="is_released === true ? 'success' : is_released === false ? 'error' : ''" label>Released: {{is_released === null ? 'NF' : is_released}}</v-chip>
          </template>
          <v-list>
            <v-list-item v-for="(releaseStatus, index) in releasedSelectOptions" :key="index" @click="is_released = releaseStatus.value">
              <v-list-item-title>{{releaseStatus.text}}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn-toggle @change="" v-model="scopes" multiple>
          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-btn v-on="on" value="awaitingPrep">
                <v-chip class="error white--text" x-small></v-chip>
              </v-btn>
            </template>
            <span>Samples Awaiting Prep</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-btn v-on="on" value="testWeighed">
                <v-chip class="amber black--text" x-small></v-chip>
              </v-btn>
            </template>
            <span>Samples with tests that are weighed(prepped)</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-btn v-on="on" value="qaAbleTest">
                <v-chip class="success white--text" x-small></v-chip>
              </v-btn>
            </template>
            <span>Samples With tests waiting for QA</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-btn v-on="on" value="qaRetest">
                <v-chip class="purple white--text" x-small></v-chip>
              </v-btn>
            </template>
            <span>Samples With Retests and no analytes</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-btn v-on="on" value="testComplete">
                <v-chip class="blue white--text" x-small></v-chip>
              </v-btn>
            </template>
            <span>Samples With Completed Tests</span>
          </v-tooltip>
        </v-btn-toggle>
        <v-text-field v-model="sample_note" label="Search notes" clearable></v-text-field>
      </v-col>
    </template>
  </div>
</template>

<script>
export default {
    name: "SampleFilterOptions",
    components: {},
    data: () => ({
      orderByItems: [
        { id: 1, name: 'Sample ID Descending', key: "id", desc: true},
        { id: 2, name: 'Sample ID Ascending', key: "id", desc: false},
        { id: 3, name: 'Created At Descending', key: "created_at", desc: true},
        { id: 4, name: 'Created At Ascending', key: "created_at", desc: false},
      ],
      selectedOrder: {name: 'Sample ID Descending', key: "id", desc: true},
      defaultedOrder: {name: 'Sample ID Descending', key: "id", desc: true},
      scopes: [],
      qaApprovedSelectOptions: [
        {text: "Qa approved", value: true},
        {text: "Not Qa approved", value: false},
        {text: "No Filter", value: null}
      ],
      releasedSelectOptions: [
        {text: "Released", value: true},
        {text: "Not Released", value: false},
        {text: "No Filter", value: null}
      ],
      sample_note: null,
      qa_approved: null,
      is_released: null,
    }),
    props:{
      default_query:{
       default: false,
       required: false,
      }
    },
    mounted(){
      if(this.default_query){
        this.setDefaults();
      }
    },
    watch: {
      selectedOrder(){
        this.$emit("query")
      },
      scopes(){
        this.$emit("query")
      },
      qa_approved(){
        this.$emit("query")
      },
      is_released(){
        this.$emit("query")
      },
    },
    methods: {
      setDefaults(){
        const keys = Object.keys(this.default_query);
        keys.forEach(key => {
          this[key] = this.default_query[key];
        })
      },
      buildQuery(){
        let query = {};
        if(this.selectedOrder.desc){
          query.order_by_desc = this.selectedOrder.key
        }else{
          query.order_by = this.selectedOrder.key
        }
        if(this.scopes.length > 0){
          query.scoped_queries = this.scopes;
        }
        if(this.qa_approved !== null || this.is_released !== null){
          query.where = [];
          if(this.qa_approved !== null){
            query.where.push({key: 'qa_approved', value: this.qa_approved})
          }
          if(this.is_released !== null){
            query.where.push({key: 'is_released', value: this.is_released})
          }
        }
        if(this.sample_note){
          query.where_has = [];
          query.where_has.push({
            relation: "sampleNotes",
            where: [
              {key: "note", condition: "ILIKE", value: `%${this.sample_note}%`}
            ]
          })
        }
        return query;
      },
      resetFilters(){
        this.scopes =  [];
        this.qa_approved =  null;
        this.is_released =  null;
        this.selectedOrder = this.defaultedOrder;
      }
    }
}
</script>

<style scoped>

</style>
